<template>
  <div class="mt-3">
    <h2 class="fw-bold">
      <span class="text-teal">Eventos</span>
    </h2>
  </div>
  <div class="card border-start border-start-width-3 border-start-teal">
    <form @submit.prevent="search">
      <div class="card-body">
        <div class="row align-items-center g-3">
          <div class="col-md-5">
            <select
              class="form-select select2"
              v-model="v$.filters.eventoPeriodoId.$model"
              v-select2
            >
              <option value="" disabled>Selecione o Ano</option>
              <option
                v-for="periodo in periodosEventos"
                :key="periodo.id"
                :value="periodo.id"
                :title="periodo.ano"
              >
                {{ periodo.ano }}
              </option>
            </select>
          </div>
          <div class="col-md-5">
            <select
              class="form-select select2"
              v-model="v$.filters.periodo.$model"
              v-select2
            >
              <option value="" disabled>Considerar o Valor</option>
              <option value="1" title="Proposto">Proposto</option>
              <option value="2" title="Reformulado">Reformulado</option>
            </select>
          </div>
          <div class="col-md-2">
            <button
              type="submit"
              class="btn btn-success w-100"
              title="Buscar"
              :disabled="v$.$invalid || loadData"
            >
              <span v-if="loadData">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Buscar</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <LoadingData v-if="loadData" />
  <EventosResult
    v-if="eventos.periodo"
    :filters="filters"
    :eventos="eventos"
    @searchData="search"
  />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import EventosResult from '@/components/eventos/EventosResult.vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import select2 from 'select2'

export default {
  name: 'Eventos',

  components: {
    LoadingData,
    EventosResult,
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      periodosEventos: [],
      filters: {
        eventoPeriodoId: '',
        periodo: '',
      },
      eventos: {},
      loadData: false,
    }
  },

  watch: {
    filters: {
      handler(newVal, oldVal) {
        if (newVal.eventoPeriodoId || newVal.periodo) {
          this.eventos = {}
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async getPeriodosEventos() {
      try {
        this.periodosEventos = await this.$store.dispatch('getPeriodosEventos')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async search() {
      if (!this.v$.$invalid) {
        this.loadData = true
        try {
          this.eventos = {}

          this.eventos = await this.$store.dispatch('getEventos', this.filters)

          this.loadData = false
        } catch (error) {
          this.loadData = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      filters: {
        eventoPeriodoId: {
          required,
        },
        periodo: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getPeriodosEventos()
    window.$('.select2').select2({ width: '100%' })
  },
}
</script>
